import { useRef } from "react";
import { useInView } from "../hooks/useInView";

export default function Reveal({ children, delay = 0, dir = "up" }) {
  const ref = useRef(null);
  const vis = useInView(ref);
  const t = {
    up:    "translateY(28px)",
    left:  "translateX(-28px)",
    right: "translateX(28px)",
  }[dir];

  return (
    <div
      ref={ref}
      style={{
        opacity:    vis ? 1 : 0,
        transform:  vis ? "none" : t,
        transition: `opacity 0.7s ease ${delay}s, transform 0.7s ease ${delay}s`,
      }}
    >
      {children}
    </div>
  );
}
